import React from 'react';
import { makeCSS } from '../../../utils/makeCSS';
import { Typography } from '../Typography';
import { NavItem } from './NavItem';

interface LinkerProps<M extends string = string> extends NavItem {
  admin?: boolean;
  modal?: M;
}

interface LinkerGroup<M extends string = string> {
  groupName: string;
  items: LinkerProps<M>[];
  alignBottom?: boolean;
  title?: string;
}

export interface NavGroupProps<M extends string = string> {
  group: LinkerGroup<M>;
  isAdmin: boolean;
  renderNavItem?: (item, config) => JSX.Element;
  onItemClick: (item: LinkerProps<M>, ev?: React.MouseEvent) => void;
  isActive: (item: LinkerProps<M>) => boolean;
  failedStatus?: boolean;
}

const useCSS = makeCSS(({ theme }) => {
  return {
    navigationGroupTitle: {
      marginLeft: 16,
      marginBottom: '12px'
    }
  };
});

export const NavGroup = <M extends string = string>(props: NavGroupProps<M>) => {
  const { group, isAdmin, renderNavItem, onItemClick, isActive, failedStatus } =
    props;
  const classes = useCSS();

  if (!isAdmin && group.items.filter((i) => !i.admin).length < 1) {
    return null;
  }

  return (
    <div>
      {group.title && (
        <div className={classes.navigationGroupTitle}>
          <Typography variant="md" weight="label" colorVariant="03">
            {group.title}
          </Typography>
        </div>
      )}
      {group.items.map((i, idx) =>
        i.admin && !isAdmin ? null : renderNavItem ? (
          renderNavItem(i, {
            isActive: isActive(i),
            onClick: () => onItemClick(i),
            failedStatus
          })
        ) : (
          <NavItem
            key={i.linkTitle + idx}
            item={i}
            isActive={isActive(i)}
            onClick={(ev?: React.MouseEvent) => onItemClick(i, ev)}
            failedStatus={failedStatus}
          />
        )
      )}
    </div>
  );
};
